import { ContactPixelRetargeting } from "../../../../src/components/retargetting";
import FormContent from "../../../../src/pages/pricing/form-content.md";
import * as React from 'react';
export default {
  ContactPixelRetargeting,
  FormContent,
  React
};